import { connect } from 'react-redux';
import GenericLoader, { buildLoader } from '../util/GenericLoader';
import {
  getDeploymentsAction,
  getDeploymentConfigAction,
  getHeartbeatsAction,
} from '../../redux/actions/deployments';

export const DeploymentsLoader = buildLoader(getDeploymentsAction);

export const HeartbeatsLoader = buildLoader(getHeartbeatsAction);

export const DeploymentConfigLoader = connect(null, (dispatch, { site }) => ({
  fetchFunction: () => {
    dispatch(getDeploymentConfigAction(site));
  },
}))(GenericLoader);
